/**
 * Makes the entire .card__compare div clickable.
 * Clicking anywhere on the div triggers the hidden checkbox inside it.
 * Clicks directly on the <input> or <label> are left untouched (they already work).
 */
document.addEventListener('click', function (e) {
  var div = e.target.closest('.card__compare');
  if (!div) return;

  // If the user clicked the checkbox or the label directly, do nothing extra
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL') return;
  if (e.target.closest('label')) return;

  var checkbox = div.querySelector('input[type="checkbox"]');
  if (checkbox) checkbox.click();
});
